export const EQUIVALENT_EXCHANGE_RATE = 1
